import ModuleHeader from "../components/ModuleHeader/ModuleHeader";

const tabs = [
  {
    id: "studentIdCard",
    title: "Student ID Card",
    icon: "ri-id-card-line",
    path: "/student/id-card",
  },
  {
    id: "staffIdCard",
    title: "Staff ID Card",
    icon: "ri-pass-valid-line",
    path: "/idcard_staff",
  },
  {
    id: "profileUpdate",
    title: "Profile Update",
    icon: "ri-account-pin-box-line",
    path: "/idcard/student",
  },
  {
    id: "tc",
    title: "Transfer Certificate",
    icon: "ri-file-paper-2-line",
    path: "/student/transfer-certificate",
  },
  {
    id: "cc",
    title: "Character Certificate",
    icon: "ri-file-list-3-line",
    path: "/student/character-certificate",
  },
  {
    id: "sc",
    title: "Study Certificate",
    icon: "ri-file-text-line",
    path: "/student/study-certificate",
  },
];

export default function IdCardLayout({ children }) {
  return;
  
  return (
    <>
      <ModuleHeader tabs={tabs} />

      {children}
    </>
  );
}
